import React from "react";
import { NonNullableItemState } from "../../redux/state";
import { Skeleton } from "@material-ui/lab";
import { ScrollableAreaTabs as CoreScrollableAreaTabs } from "@ofqual/portal-components/components/ScrollableAreaTabs";
import { UnitActivityFeed } from "./activityFeed/UnitActivityFeed";
import {
  LinkedRecords,
  LinkedRecordType,
} from "@ofqual/portal-linked-records/linked-records";

export const UnitScrollableAreaTabs: React.FC<{
  itemState: NonNullableItemState | null;
}> = ({ itemState }) => {
  return itemState && itemState.item ? (
    <CoreScrollableAreaTabs
      dataTest="unit-tabs"
      tabs={[
        {
          label: "Activity",
          content: <UnitActivityFeed unitItem={itemState.item}
           />,
        },
        {
          label: "Linked Records",
          content: (
            <LinkedRecords
              entityReferenceId={itemState.item.id}
              entityTitle={itemState.item.title}
              entityLinkedRecordType={LinkedRecordType.unit}
                          />
          ),
          tabTypeId: "linkedRecords",
        },
      ]}
    ></CoreScrollableAreaTabs>
  ) : (
    <>
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="text" height={60} />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="rect" height={118} />
      <br />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="text" height={60} />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="rect" height={118} />
    </>
  );
};
